<div class="paginado">
	<a *ngIf="itemsLength > itemsPerPage && newstartpage !== 0" class="pag_anterior" (click)="onPreviousPage()"
		>Anterior</a
	>
	<a *ngFor="let item of paginatorItems" (click)="selectPage(item)">
		<a [ngClass]="{ pag_active: item === currentPage, dots: item === -1 }">
			{{ item === -1 ? '...' : item }}
		</a>
	</a>
	<a
		*ngIf="itemsLength > itemsPerPage && itemsLength > newstartpage + itemsPerPage"
		class="pag_siguiente"
		(click)="onNextPage()"
		>Siguiente</a
	>
</div>
